<template>
  <div v-title data-title="重置密码">
    <wv-group>
      <wvi-input
        label="手机号"
        placeholder="手机号"
        v-model="formset.Telephone"
        ref="3"
        :disabled="telephonedisabled"
        pattern="^[1][3,4,5,7,8,9][0-9]{9}$"
        maxlength="11"
        :validate-info="{errormsg:'联系电话不合法'}"
        required
      ></wvi-input>
      <wvi-input
        label="重置密码"
        type="password"
        ref="4"
        placeholder="请输入密码"
        v-model="formset.Password"
        :validate-info="{errormsg:'密码不可为空'}"
        required
      ></wvi-input>
      <wvi-input label="确认密码" type="password" placeholder="请输入密码" v-model="formset.confirmpassword"></wvi-input>
      <div
        v-if="(formset.Password!=formset.confirmpassword)"
        class="weui-cells__tips"
        style="color: rgb(230, 67, 64); text-align: center;"
      >
        <i data-v-5c55cccb class="weui-icon-warn"></i>
        密码不一致
      </div>
      <div class="weui-cell weui-cell_vcode">
        <div class="weui-cell__bd">
          <input class="yzm" type="text" placeholder="验证码" v-model="PicCodeValue">
        </div>
        <img  @click="getpiccode()" v-bind:src="'data:image/png;base64,'+VerificationCodePic.Base64" style="width:25%;margin-right:3%">
      </div>
      <div class="weui-cell weui-cell_vcode">
        <div class="weui-cell__bd">
          <input
            class="yzm"
            type="tel"
            placeholder="请输入验证码"
            maxlength="6"
            v-model="code"
          >
          <div class="btn-vercode">
            <button
              class="weui-btn weui-btn_mini btn-orange"
              style="width:inherit"
              v-if="getcodeshow&&formset.Telephone.length==11&&PicCodeValue.length>0"
              @click="getcode()"
            >获取验证码</button>
            <button
              class="weui-btn weui-btn_mini btn-orange"
              style="width:inherit"
              v-if="getcodeshow&&(formset.Telephone.length!=11||PicCodeValue.length==0)"
            >获取验证码</button>
            <button
              class="weui-btn weui-btn_mini btn-orange"
              style="width:inherit;background-color:#ccc"
              v-if="!getcodeshow"
            >{{waitminutes}}秒</button>
          </div>
        </div>
      </div>
      <div class="weui-cell">
        <wv-button type="primary" @click="reset()">重置</wv-button>
      </div>
    </wv-group>
  </div>
</template>
<script>
import { Toast } from "we-vue";
export default {
  name: "passwordset",
  data() {
    return {
      LoginType: -1, //(-1=未登录/4=家游客/5=直客)
      formset: { Telephone: "",confirmpassword:"",Password:"" },
      getcodeshow: true,
      waitminutes: "",
      codetimer: null,
      code: "",
      telephonedisabled: false,
      VerificationCodePic: { OnceString: "" }, //图形验证码信息
      PicCodeValue: "" //图形验证码值
    };
  },
  created: function() {
    var url = window.location.href;
    var loginType = this.GetRequest(url)["logintype"];
    if (loginType != undefined && loginType != null && loginType.length > 0) {
      this.LoginType = loginType;
    }
    this.InitMessage();
    this.getpiccode();
  },
  methods: {
    InitMessage: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/dispersonalinfo", {})
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.formset = rep.Data;
              this.telephonedisabled = rep.Data.Type != -1 ? true : false;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    reset: function() {
      if (this.formset.Password != this.formset.confirmpassword) {
        
        return;
      }
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/resetpassword", {
          params: {
            telephone: this.formset.Telephone,
            password: this.formset.Password,
            loginType: this.LoginType,
            code: this.code
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              Toast.success("重置成功");
              this.$router.push("/app/us");
            } else {
              this.getpiccode();
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    //获取图形验证码
    getpiccode: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getverificationcodepic", {
          params: { codeGuid: this.VerificationCodePic.OnceString }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.VerificationCodePic = rep.Data;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    //获取验证码
    getcode: function() {
      if (this.formset.Telephone == "") {
        Toast.fail("手机号不能为空");
        return;
      }
      if (this.PicCodeValue == "") {
        Toast.fail("图形验证码不能为空");
        return;
      }
      const TIME_COUNT = 60;
      if (!this.codetimer) {
        this.waitminutes = TIME_COUNT;
        this.getcodeshow = false;
        this.codetimer = setInterval(() => {
          if (this.waitminutes > 0 && this.waitminutes <= TIME_COUNT) {
            this.waitminutes--;
          } else {
            this.getcodeshow = true;
            clearInterval(this.codetimer);
            this.codetimer = null;
          }
        }, 1000);
      }
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getverificationcode", {
          params: {
            picCode: this.PicCodeValue,
            onceString: this.VerificationCodePic.OnceString,
            telephone: this.formset.Telephone,
            loginType: this.LoginType
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
            } else {
              this.waitminutes = 0;
              this.getpiccode();
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/set/passwordset.vue